import { Box, Grid, Heading, Text } from 'theme-ui';
import Button from '@/components/Button';
import React, { useState } from 'react';
import { useResetDemoAccountsMutation } from '@/store/apiService';
import { ConfirmationModal } from '../../components/ConfirmationModal';

export const ResetDemoAccounts: React.FC = () => {
    const [reset, resetState] = useResetDemoAccountsMutation();
    const [confirmationModalVisible, setConfirmationModalVisible] = useState(false);

    return (
        <>
            {confirmationModalVisible ? (
                <ConfirmationModal
                    loading={resetState.isLoading}
                    content="This will wipe and reinstall every demo account. This is destructive and cannot be undone. Are you sure?"
                    onNo={() => {
                        setConfirmationModalVisible(false);
                    }}
                    onYes={() => {
                        reset();
                        setConfirmationModalVisible(false);
                    }}
                />
            ) : null}
            <Grid gap={2}>
                <Heading>Reset demo accounts</Heading>
                {resetState.isSuccess ? (
                    <Text sx={{ color: 'green.6' }}>
                        {resetState.data?.Message ?? 'Demo accounts reset.'}
                    </Text>
                ) : null}
                {resetState.isError ? (
                    <Text sx={{ color: 'danger' }}>Could not reset demo accounts.</Text>
                ) : null}
                <Box>
                    <Button
                        isLoading={resetState.isLoading}
                        variant="danger"
                        onClick={(evt) => {
                            evt.preventDefault();
                            resetState.reset();
                            setConfirmationModalVisible(true);
                        }}
                    >
                        Reset
                    </Button>
                </Box>
            </Grid>
        </>
    );
};
